import { LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function CtaSection() {
  return (
    <section
      className="py-20 sm:py-28"
      aria-labelledby="cta-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-sm bg-peninsula-magma px-6 py-16 text-center sm:px-12 sm:py-20">
          <h2
            id="cta-heading"
            className="text-3xl font-bold tracking-tight text-white sm:text-4xl"
          >
            Lleva la accesibilidad a tu portal
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-white/80">
            Disponibilidad 24/7, soporte técnico continuo y un servicio 100% cloud
            que se integra sin modificar tu sitio web.
          </p>
          <div className="mt-8">
            <Button
              asChild
              size="xl"
              variant="secondary"
              className="font-semibold"
            >
              <a href="/admin/login">
                <LogIn className="size-5" aria-hidden="true" />
                Iniciar sesión
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
